// extracted by mini-css-extract-plugin
export default {"lds_spinner":"Loaing_lds_spinner__6W6v0"};